import { useEffect, useState } from 'react';

import { TUseProcessedValue } from './useProcessedValue';
import { processHandicaps } from '../Utils/processHandicaps';

export const useProcessedHandicaps: TUseProcessedValue = (handicaps, start, end, partials) => {
  const [processedHandicaps, setprocessedHandicaps] = useState<string[]>([]);

  useEffect(() => {
    const newprocessedHandicaps = processHandicaps(handicaps, start, end, partials);

    setprocessedHandicaps(newprocessedHandicaps);
  }, [handicaps, start, end, partials]);

  return processedHandicaps;
};
